import React from "react";
import InstoBottle from "../assets/insto-bottle.png";
import InstoBottle2 from "../assets/insto-bottle-2.png";
import InstoBottle3 from "../assets/insto-bottle-3.png";
import InstoBottleEffect from "../assets/new/center-insto-effect.png";
import { GAME_CONFIG } from "../config";

export default function CenteredInstoBottle({
  foundHotspots,
  currentStage,
  setFoundHotspots,
}) {
  const lastStageIndex = GAME_CONFIG.lastStageIndex;
  function handleClickCenterInsto() {
    let foundHotspotsCopy = JSON.parse(localStorage.getItem("foundHotspots"));
    foundHotspotsCopy[currentStage] = foundHotspotsCopy[currentStage] + 1;
    setFoundHotspots(foundHotspotsCopy);
  }

  let bottleImg = InstoBottle;
  if (currentStage == lastStageIndex - 1) {
    bottleImg = InstoBottle2;
  } else if (currentStage == lastStageIndex) {
    bottleImg = InstoBottle3;
  }

  return (
    <div>
      {foundHotspots[currentStage] === 3 && (
        <div className={`insto-center insto-center-${currentStage}`}>
          <img className="effect" src={InstoBottleEffect} alt="" />
          <img
            className={`insto-center-img insto-center-img-${currentStage}`}
            onClick={handleClickCenterInsto}
            src={bottleImg}
            alt=""
          />
          <p>Klik disini</p>
        </div>
      )}
    </div>
  );
}
